<template>
    <div class="page">
        <div class="top">
            <div class="name">当前套餐</div>
            <div class="top-flex">
                <div class="top-flex-item">
                    <div class="top-flex-item-name">当前套餐</div>
                    <div class="top-flex-item-value" v-if="simInfo.isNoLimitData == 1">无限量</div>
                    <div class="top-flex-item-value" v-else>{{ fluxMtoG(simInfo.flowRate || 0) }}GB</div>
                </div>
                <div class="top-flex-item">
                    <div class="top-flex-item-name">通用流量</div>
                    <div class="top-flex-item-value">{{ fluxMtoG(simInfo.usedFlowRate || 0) }}GB</div>
                </div>
                <div class="top-flex-item">
                    <div class="top-flex-item-name">剩余流量</div>
                    <div class="top-flex-item-value" v-if="simInfo.isNoLimitData == 1">无限量</div>
                    <div class="top-flex-item-value" v-else>{{ fluxMtoG(simInfo.surplusFlowRate || 0) }}GB</div>
                </div>
            </div>
        </div>
        <div class="user-name">
            <div class="l-user-name">
                <img src="@/assets/she/icon27.png" alt="">
            </div>
            <div class="r-user-name">
                <div class="r-user-name-top">Hi, {{ recordLoginText }}</div>
                <div class="r-user-name-c">
                    <div class="city">{{ simInfo.city }}</div>
                    <div class="city">网龄 {{ simInfo.simYear }}</div>
                    <div class="city">
                        <img src="@/assets/she/icon25.png" alt="">
                        <div class="jx"> {{ simInfo.vipLever }}星</div>
                    </div>
                    <div class="city">余额 {{ money_format(userSimAmount / 100, 2, ".", ",") * 1 }}元</div>
                </div>
            </div>
        </div>
        <div class="scell-items">
            <div class="scell-btn" :class="[index === inx ? 'active' : '']" @click="titleChange(item, index)"
                v-for="(item, index) in titleList" :key="index">{{ item }}</div>
        </div>
        <div class="content">
            <div class="content-l" :class="[item.id === sId ? 'active' : '']" v-for="item in allList" :key="item.id"
                @click="changeList(item)">
                <img :src="item.sheImg" alt="">
            </div>
        </div>
        <div class="footer">
            <div class="f-l">
                <div class="price">
                    <div>￥</div>
                    <div class="price-num">{{ setObj.salePriceRmb }}</div>
                    <div>元</div>
                </div>
                <div class="yh">已优惠
                    {{ setObj.sheOldPrice && setObj.sheOldPrice - setObj.salePriceRmb > 0 ? setObj.sheOldPrice -
                        setObj.salePriceRmb : 0 }}元
                </div>
            </div>
            <div class="f-r">
                <div class="btn yezf" @click="showPopup">余额支付</div>
                <div class="btn wxzf" @click="hidePopup">在线支付</div>
            </div>
        </div>
        <!--余额支付-->
        <van-popup v-model:show="showBottom" position="bottom" :round="true">
            <div class="title">余额支付</div>
            <div class="zf-price">
                <div class="zf-price-item" :class="[item.active ? 'active' : '']" v-for="(item, index) in swipeList"
                    :key="index" @click="changeAmount(item)">
                    <div class="price">￥<span>{{ item.amount }}</span></div>
                    <div class="zf-yh">送{{ item.giftBalance }}元</div>
                    <div class="zf-hd">{{ item.title }}</div>
                </div>
            </div>
            <div class="sm" @click="shuoming">
                预存说明
            </div>
            <div class="cu-footer">
                <!--未选择套餐-->
                <div class="f-l" v-if="liObj && !liObj.active">
                    <div class="price">
                        <div>￥</div>
                        <div class="price-num">{{ (setObj.salePriceRmb * 1).toFixed(2) }}</div>
                        <div>元</div>
                    </div>
                    <div class="yh">已优惠{{ setObj.sheOldPrice && setObj.sheOldPrice - setObj.salePriceRmb > 0 ?
                        setObj.sheOldPrice - setObj.salePriceRmb : 0 }}元</div>
                </div>
                <!--选择了里面套餐-->
                <div class="f-l" v-else>
                    <div class="price">
                        <div>￥</div>
                        <div class="price-num" v-if="!radio1">{{ (setObj.salePriceRmb ).toFixed(2) }}</div>
                        <div class="price-num" v-else>{{ (setObj.salePriceRmb + setObj.sheVipPrice ).toFixed(2) }}  </div>
                        <div>元</div>
                    </div>
                    <!-- <div class="yh">已优惠{{setObj.sheOldPrice && setObj.sheOldPrice - setObj.salePriceRmb > 0 ? setObj.sheOldPrice - setObj.salePriceRmb - liObj.juanPrice : 0}}元</div> -->
                    <div class="yh1" v-if="setObj.sheVipPrice&&setObj.sheVipPrice>0">
                        <van-checkbox v-model="radio1" checked-color="#C47A3A" @click="changRadio"
                            icon-size="12px"></van-checkbox>
                        VIP权益
                    </div>
                </div>
                <div class="f-r">
                    <div class="btn yezf" @click="handleSumbit">确认并支付</div>
                </div>
            </div>
        </van-popup>
        <!--微信支付-->
        <van-popup v-model:show="showBottom1" position="bottom" :round="true" :style="{ maxHeight: '85%' }">
            <pay ref="pay" />
        </van-popup>
    </div>
</template>
<script>
import pay from '@/components/pay.vue';
import { wxRequest } from '@/api/user.js'
import { Toast, Dialog } from 'vant';
export default {
    components: {
        pay
    },
    data() {
        return {
            selectYu: false,
            showYu: localStorage.getItem("showYu") == 0 ? true : false,
            userSimAmount: localStorage.getItem('userSimAmount'),
            recordLoginText: localStorage.getItem("recordLoginText"),
            h_top: 0,
            isShow: false,
            isShow1: false,
            num: 0,
            radio1: true,
            tuiObj: {}, //推荐套餐
            allList: [],// 全部套餐
            isAdmin: '',
            setObj: {},
            isMore: false,
            dataForm: {},
            swipeList: [],
            currentIndex: null,
            titleList: [],
            remaky: "",
            liObj: {},
            simInfo: {},
            inx: 0,
            sId: '',
            iccid: localStorage.getItem('iccid'),
            showBottom: false,
            showBottom1: false
        };
    },
    mounted() {
        // localStorage.setItem("iccid", "8888888888888877777777");
        // localStorage.setItem('recordLoginText', '8888888888888877777777');
        // this.$store.state.iccid = "8888888888888877777777";

        wxRequest("sim/detail", { iccid: this.iccid }, "post").then(res => {
            if (res.data.code === '200') {
                this.simInfo = res.data.data;
                this.pkgInit()
            }
        })
    },
    methods: {
        changRadio(status) {
            console.log(this.num)
            if (this.num < 10) {
                this.num++
                this.radio1 = true
            }
        },
        pkgInit() {
            wxRequest("she/select/pkgType", { basePkgGroup: this.simInfo.basePkgGroup }, "post").then(res => {
                if (res.data) {
                    this.titleList = res.data.data
                    this.changeType(res.data.data[0])
                }
            })

        },
        changeType(data) {
            wxRequest("sim/user/soldPkg", { iccid: this.iccid, sheTypeName: data }, "get").then(res => {
                if (res.data.code === '200') {
                    this.isAdmin = res.data.data.isAdmin
                    this.allList = res.data.data.list.map(item => {
                        item.sheImg = process.env.VUE_APP_IMG_URL + '/' + item.sheImg
                        return item
                    })
                    this.sId = res.data.data.id
                    this.changeList(this.allList[0])
                } else {
                    Toast(res.data.message)
                }
            })
        },
        titleChange(item, index) {
            this.inx = index
            this.changeType(item)
        },
        //选择套餐
        changeList(item) {
            this.sId = item.id
            this.setObj = item
        },
        changeAmount(data) {
            this.swipeList.map(item => {
                item.sheVipPrice = item.sheVipPrice || 0
                item.addPrice = item.addPrice || 0
                item.juanPrice = item.juanPrice || 0
                if (item.amount === data.amount) {
                    item.active = !item.active
                } else {
                    item.active = false
                }
                return item
            })
            this.liObj = this.swipeList.find(item => item.active)
            this.$forceUpdate()
        },
        showPopup() {
            this.showBottom = true;
            wxRequest("sim/uniorder/param", { iccid: this.iccid }, "post").then(res => {
                this.swipeList = res.data.data
                this.swipeList.map(item => {
                    item.sheVipPrice = item.sheVipPrice || 0
                    item.addPrice = item.addPrice || 0
                    item.active = false
                    item.juanPrice = item.juanPrice || 0
                    return item
                })
                this.swipeList[0].active = true
                this.liObj = this.swipeList[0]
                console.log(11111,this.liObj)
            })

        },
        //余额支付
        handleSumbit() {
            var data = {
                iccid: this.iccid,
                amount: this.liObj.amount,//选中的金额,
                giftBalance: this.liObj.giftBalance,//赠送的金额,
                payPass: '000000',
                isAdmin: this.isAdmin,//此参数在获取套餐页面返回的
                soldPackageId: this.setObj.id, //用户选择的套餐
                isNextMonth: 0,
                payType: 0,
                mobile: '',
                // sheVipPrice: this.setObj.sheVipPrice, //套餐接口返回的
               // addPrice: this.liObj.addPrice, //套餐接口返回的
               // juanPrice: this.liObj.juanPrice //套餐接口返回的
            }
            if(this.radio1){
                data.sheVipPrice = this.setObj.sheVipPrice
            }
            wxRequest('sim/get/pay/state', { iccid: this.iccid }, 'post').then(res => {
                if (res.data.code == 200) {
                    data.payType = 50;//乐刷
                } else if (res.data.code == 201) {
                    data.payType = 62;//云游
                } else {
                    data.payType = 20;//微信
                }
                wxRequest('order/user/create/investOrder', data, 'post').then(res => {
                    if (res.data.code == 200) {
                        if (data.payType == 50) {
                            window.location.href = res.data.data.jspay_url;
                        } else if (data.payType == 62) {
                            window.location.href = res.data.data;
                        } else {
                            if (typeof WeixinJSBridge == "undefined") {
                                if (document.addEventListener) {
                                    document.addEventListener('WeixinJSBridgeReady', this.onBridgeReady, false);
                                } else if (document.attachEvent) {
                                    document.attachEvent('WeixinJSBridgeReady', this.onBridgeReady);
                                    document.attachEvent('onWeixinJSBridgeReady', this.onBridgeReady);
                                }
                            } else {
                                let param = res.data.data.param;
                                this.onBridgeReady(param);
                            }
                        }
                    } else {
                        Dialog.alert({ title: '提示', message: res.data.message });
                    }
                });


            });
        },
        hidePopup() {
            this.showBottom1 = true;
            this.$nextTick(() => {
                wxRequest("she/select/auto/manager", { iccid: this.iccid, soldPackageId: this.setObj.id }, "post").then(res => {
                    if (res.data.code === '200') {
                        this.setObj.sheXuPrice = res.data.data.sheXuPrice;
                        this.setObj.sheXuPrice = res.data.data.sheXuPrice;
                        this.setObj.juanPrice = res.data.data.juanPrice;
                        this.setObj.sheVipKefu = res.data.data.sheVipKefu
                        this.setObj.sheVipPrice = res.data.data.sheVipPrice
                        this.setObj.sheVipRemark = res.data.data.sheVipRemark
                        this.setObj.isShowAddPkg = res.data.data.isShowAddPkg
                        this.$refs.pay.init({ ...this.setObj, iccid: this.iccid, isAdmin: this.isAdmin })
                    } else {
                        Toast(res.data.message)
                    }
                })
            })
        },

        shuoming() {
            Dialog.confirm({
                title: '关于预存说明',
                width: '90%',
                showCancelButton: false,
                messageAlign: 'left',
                confirmButtonColor: '#ee0a24',
                message: `充值预存后，系统将会自动订购选择的套餐。请合理选择对应套餐后 再进行选择充值。
            `,
            }).then(() => {
                // on confirm
            }).catch(() => {
                // on cancel
            });
        },
        onBridgeReady(param) {
            let _this = this;
            WeixinJSBridge.invoke('getBrandWCPayRequest', param, function (res) {
                if (res.err_msg == "get_brand_wcpay_request:ok") {
                    _this.$router.push({
                        path: "/she/home",
                        query: {
                            iccid: _this.$store.state.iccid,
                        },
                    })
                        .catch(() => { });

                }
            });
        },
    },
}
</script>
<style lang="less" scoped>
.page {
    background: linear-gradient(180deg, #3980F9 0%, rgba(247, 250, 255, 0) 30%), #F6F9FF;
    height: 100vh;

    /* padding-bottom: 58px; */
    .top {
        background: url('~@/assets/she/icon26.png') no-repeat center center;
        background-size: 100% 100%;
        width: 100%;

     
        
        .name {
            text-align: center;
            font-family: PingFangSC, PingFang SC;
            font-weight: bold;
            font-size: 20px;
            color: #FFFFFF;
            line-height: 25px;
            margin-bottom: 4px;
        }

        .top-flex {
            display: flex;
            justify-content: space-between;
            width: calc(100% - 80px);
            padding: 0 40px;
            padding-bottom: 8px;
            font-family: PingFangSC, PingFang SC;

            .top-flex-item {
                display: flex;
                align-items: center;

                .top-flex-item-name {
                    font-size: 12px;
                    color: #fff;
                }

                .top-flex-item-value {
                    font-family: HarmonyOS_Sans_SC_Bold;
                    font-size: 12px;
                    margin-left: 5px;
                    font-weight: 600;
                    color: #fff;
                }
            }
        }
    }

    .user-name {
        display: flex;
        align-items: center;
        margin-top: 18px;
        padding: 0 14px;

        .l-user-name {
            width: 52px;
            height: 52px;
            margin-right: 11px;

            img {
                width: 100%;
                height: 100%;
            }
        }

        .r-user-name {
            .r-user-name-top {
                font-family: PingFangSC, PingFang SC;
                font-size: 18px;
                color: #fff;
                line-height: 25px;
            }

            .r-user-name-c {
                display: flex;
                align-items: center;
                margin-top: 5px;

                .city {
                    font-family: PingFangSC, PingFang SC;
                    font-size: 10px;
                    color: #fff;
                    margin-right: 5px;
                    background: #3769DF;
                    border-radius: 8px;
                    padding: 3px 5px;
                }
            }
        }
    }

    .city {
        display: flex;
        align-items: center;

        img {
            width: 15px;
            height: 15px;
            margin-right: 5px;
        }
    }

    .scell-items {
        display: flex;
        justify-content: space-between;
        width: calc(100% - 28px);
        margin: 0 auto;
        margin-top: 20px;
        overflow-x: auto;
        /* 允许水平滚动 */
        scroll-snap-type: x mandatory;

        /* 确保元素在滚动停止时对齐 */
        .scell-btn {
            /* width: 100%; */
            height: 40px;
            background: #397EF5;
            border-radius: 10px;
            color: #fff;
            font-family: PingFangSC, PingFang SC;
            font-size: 14px;
            line-height: 38px;
            text-align: center;
            margin-right: 10px;
            flex: 0 0 auto;
            /* 不允许flex项伸缩 */
            width: 100px;
            /* 或其他固定宽度 */
            padding: 5px 9px;
            scroll-snap-align: start;
            /* 确保项在滚动停止时对齐 */
        }

        .scell-btn:last-child {
            margin-right: 0;
        }

        .active {
            background: url('~@/assets/she/icon28.png') no-repeat center center;
            background-size: 100% 100%;
            height: 44px;
        }
    }

    .content {
        width: calc(100% - 28px);
        margin: 0 auto;
        margin-top: 10px;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        padding-bottom: 58px;

        .content-l {
            width: 49%;
            height: 168px;
            background: #fff;
            border-radius: 10px;
            margin-bottom: 12px;
            border: 1px solid #fff;

            img {
                width: 100%;
                height: 100%;
                border-radius: 10px;
            }
        }

        .content-l:last-child {
            margin-bottom: 0;
        }

        .content-l.active {
            border: 1px solid red;
        }
    }

    .footer {
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        height: 58px;
        background: #fff;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 14px;
        width: calc(100% - 28px);

        .f-l {
            display: flex;
            align-items: end;

            .price {
                display: flex;
                align-items: end;
                font-family: PingFangSC, PingFang SC;
                font-size: 18px;
                color: #F35631;
                font-weight: bold;

                div {
                    margin-right: 5px;
                    font-size: 12px;
                }

                .price-num {
                    font-family: HarmonyOS_Sans_SC_Bold;
                    font-size: 24px;
                    color: #F35631;
                    margin-right: 5px;
                }
            }

            .yh {
                font-family: PingFangSC, PingFang SC;
                font-size: 12px;
                color: #F35631;
            }

        }

        .f-r {
            display: flex;
            align-items: center;

            .btn {
                width: 100px;
                height: 40px;
                border-radius: 20px;
                color: #fff;
                font-family: PingFangSC, PingFang SC;
                font-size: 14px;
                line-height: 38px;
                text-align: center;
            }

            .yezf {
                background: #397EF5;
                margin-right: 8px;
                animation: zoomInOut 2s ease-in-out infinite;
            }

            .wxzf {
                background: #00D206;
            }
        }
    }

    @keyframes zoomInOut {
        0% {
            transform: scale(1);
            /* 初始状态，无放大 */
        }

        50% {
            transform: scale(.7);
            /* 中间状态，放大到150% */
        }

        100% {
            transform: scale(1);
            /* 结束状态，缩小回原始大小 */
        }
    }

    .van-popup {
        background: linear-gradient(180deg, #A9CAFA 0%, #FFFFFF 40%);

        .title {
            font-family: PingFangSC, PingFang SC;
            font-weight: 500;
            font-size: 16px;
            color: #1D1B19;
            text-align: center;
            padding: 20px 0;
        }

        .zf-price {
            display: flex;
            width: calc(100% - 28px);
            margin: 0 auto;
            margin-top: 20px;
            flex-wrap: wrap;

            .zf-price-item {
                position: relative;
                width: 30%;
                height: 80px;
                border-radius: 10px;
                padding: 18px 0;
                border: 1px solid #4980E9;
                margin-right: 11px;
                text-align: center;

                .price {
                    font-family: PingFangSC, PingFang SC;
                    font-size: 18px;
                    color: #F35631;
                    padding-top: 20px;
                    padding-bottom: 12px;

                    div {
                        margin-right: 5px;
                        font-size: 12px;
                    }

                    span {
                        font-family: HarmonyOS_Sans_SC_Bold;
                        font-size: 28px;
                        color: #F35631;
                        font-weight: bold;
                        margin-right: 5px;
                    }
                }

                .zf-yh {
                    font-family: PingFangSC, PingFang SC;
                    font-size: 12px;
                    color: #F35631;
                }

                .zf-hd {
                    font-family: PingFangSC, PingFang SC;
                    font-size: 12px;
                    color: #fff;
                    background: linear-gradient(270deg, #98BFF7 0%, #4980E9 100%);
                    border-radius: 15px;
                    position: absolute;
                    text-align: center;
                    top: -16px;
                    height: 32px;
                    line-height: 30px;
                    left: 0;
                    right: 0;
                    margin: auto;
                }

                &:nth-child(3n) {
                    margin-right: 0;
                }
            }

            .active {
                border: 1px solid #F35631;
            }
        }

        .sm {
            font-family: PingFangSC, PingFang SC;
            font-size: 12px;
            color: #F35631;
            height: 30px;
            line-height: 30px;
            margin-top: 20px;
            background: url('~@/assets/she/icon29.png') no-repeat center left;
            background-size: 18px 18px;
            padding-left: 24px;
            margin-left: 14px;
        }

        .cu-footer {
            height: 58px;
            background: #fff;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 0 14px;
            width: calc(100% - 28px);
            margin-top: 20px;

            .f-l {

                display: flex;
                align-items: end;

                .price {
                    display: flex;
                    align-items: end;
                    font-family: PingFangSC, PingFang SC;
                    font-size: 18px;
                    color: #F35631;
                    font-weight: bold;

                    div {
                        margin-right: 5px;
                        font-size: 12px;
                    }

                    .price-num {
                        font-family: HarmonyOS_Sans_SC_Bold;
                        font-size: 24px;
                        color: #F35631;
                        margin-right: 5px;
                    }
                }

                .yh {
                    font-family: PingFangSC, PingFang SC;
                    font-size: 12px;
                    color: #F35631;
                }

                .yh1 {
                    font-family: PingFangSC, PingFang SC;
                    font-size: 12px;
                    color: #F35631;
                    margin-left: 10px;
                    display: flex;
                    align-items: center;

                    ::v-deep .van-checkbox__icon {
                        margin-right: 5px;
                    }
                }
            }

            .f-r {
                display: flex;
                align-items: center;

                .btn {
                    width: 100px;
                    height: 40px;
                    border-radius: 20px;
                    color: #fff;
                    font-family: PingFangSC, PingFang SC;
                    font-size: 14px;
                    line-height: 38px;
                    text-align: center;
                }

                .yezf {
                    background: #397EF5;
                    margin-right: 8px;
                }
            }
        }
    }
}
</style>